"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ALL_URLS = void 0;
const ALL_URLS = '<all_urls>';
exports.ALL_URLS = ALL_URLS;